import {recordDocumentAdapter, type DocumentAdapter} from '@github-ui/optimistic-connection'

// Picker queries store a plain array rather than the shared adapter's nodes connection.
export const milestoneDocumentAdapter: DocumentAdapter = (document, change, context) => {
  if (
    !document ||
    typeof document !== 'object' ||
    !('repositoryId' in document) ||
    typeof document.repositoryId !== 'string' ||
    !('milestones' in document) ||
    !Array.isArray(document.milestones)
  ) {
    return undefined
  }

  const connectionDocument = {id: document.repositoryId, milestones: {nodes: document.milestones}}
  const result = recordDocumentAdapter(connectionDocument, change, context)
  if (!result) return undefined
  return {
    document:
      result.document === connectionDocument ? document : {...document, milestones: result.document.milestones.nodes},
  }
}
